var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#233544",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.592 15.207c3.689 0 6.842.559 6.842 2.792 0 2.233-3.132 2.808-6.842 2.808-3.69 0-6.842-.554-6.842-2.788s3.131-2.812 6.842-2.812ZM9.593 12.02a4.386 4.386 0 1 1 4.385-4.385 4.37 4.37 0 0 1-4.354 4.385h-.031Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#233544",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.484 10.881a3.301 3.301 0 0 0 2.837-3.262 3.3 3.3 0 0 0-2.762-3.256M18.598 14.732c1.55.231 2.634.775 2.634 1.895 0 .771-.51 1.271-1.334 1.584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyMember);
export default __webpack_public_path__ + "static/media/company-member.ce3dcbf1bbc97fd191ab6d85168a5f0e.svg";
export { ForwardRef as ReactComponent };